function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.0745 34.6485L8.84014 46.1362V62.2561H0V0H8.84014V34.8338L42.359 0H52.4883L26.1521 27.9782L54.33 62.2561H44.0165L20.0745 34.6485Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M118.789 57.2535L122.289 50.5832C126.34 53.3625 132.602 55.4006 138.68 55.4006C146.599 55.4006 149.73 52.9919 149.73 48.9156C149.73 38.3543 120.078 47.4333 120.078 28.7194C120.078 20.1963 127.629 14.6377 139.6 14.6377C145.678 14.6377 152.676 16.3053 156.728 18.8993L153.045 25.5696C148.809 22.7903 144.205 21.8639 139.6 21.8639C132.234 21.8639 128.55 24.6431 128.55 28.3489C128.55 39.466 158.202 30.387 158.202 48.7303C158.202 57.2535 150.466 62.6268 137.943 62.6268C130.392 62.8121 122.657 60.4034 118.789 57.2535Z",
  fill: "current"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M210.322 33.7221V62.2562H202.218V55.9565C199.456 60.2181 194.115 62.6268 186.748 62.6268C176.066 62.6268 169.436 56.8829 169.436 48.7303C169.436 41.1336 174.224 35.0191 188.221 35.0191H201.666V33.3516C201.666 26.1254 197.43 22.0491 189.142 22.0491C183.617 22.0491 177.908 24.0873 174.224 27.0518L170.725 20.5668C175.514 16.6758 182.512 14.4524 190.063 14.4524C203.139 14.6377 210.322 20.9374 210.322 33.7221ZM201.85 47.8039V41.1336H188.774C180.302 41.1336 177.908 44.4687 177.908 48.3597C177.908 52.9919 181.775 55.9565 188.221 55.9565C194.667 56.1418 199.824 53.3625 201.85 47.8039Z",
  fill: "current"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M91.5323 49.842V62.4415L96.8732 59.2916V46.6921L91.5323 49.842Z",
  fill: "current"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M106.266 34.4633L84.3497 21.6786L72.1945 14.6377L60.2234 35.575L60.4076 55.2153L82.1396 68.0001L84.3497 66.7031V48.1745L94.1106 30.9429L104.056 36.6867V55.2153L106.266 53.9184V34.4633Z",
  fill: "current"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 211 68",
    fill: "current",
    alt: "Logo Kasa",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a38d09aa.svg";
export { ForwardRef as ReactComponent };